<ng-container
  *ngIf="!(remoteDiagnosticsStore.isUseCasePopupBlocked$ | async); else contentWithoutModal"
>
  <div
    *ngIf="(selectedExtendedParametersTab$ | async) === extendedParametersTabsEnum.UseCases"
    class="tab"
    [class.selected]="(selectedExtendedParametersTab$ | async) === extendedParametersTab"
    gtm="onSelectExtendedParametersTab"
    gtmAction="Diagnostics Overlay"
    gtmCategory="Select extended parameters tab"
    (click)="onTabSelect()"
  >
    <div>{{ title }}</div>
  </div>
  <div
    *ngIf="
      (selectedExtendedParametersTab$ | async) === extendedParametersTabsEnum.SearchedParameters
    "
    class="tab"
    [class.selected]="(selectedExtendedParametersTab$ | async) === extendedParametersTab"
    gtm="onSelectExtendedParametersTab"
    gtmAction="Diagnostics Overlay"
    gtmCategory="Select extended parameters tab"
    [viConfirm]="{
      title: 'DIAGNOSTIC.ACTIVE_SESSION.CHANGE_TAB_MODAL_TITLE' | translate,
      content: 'DIAGNOSTIC.ACTIVE_SESSION.CHANGE_TAB_MODAL_CONTENT' | translate,
      closeIcon: true,
      confirmBtn: 'GENERAL.BUTTON.ACCEPT' | translate
    }"
    (confirm)="onTabSelect(); closePopup()"
    (cancel)="closePopup()"
  >
    <div>{{ title }}</div>
  </div>
</ng-container>
<ng-template #contentWithoutModal>
  <div
    class="tab"
    [class.selected]="(selectedExtendedParametersTab$ | async) === extendedParametersTab"
    gtm="onSelectExtendedParametersTab"
    gtmAction="Diagnostics Overlay"
    gtmCategory="Select extended parameters tab"
    (click)="onTabSelect()"
  >
    <div>{{ title }}</div>
  </div>
</ng-template>
